import { ScrollTrigger } from "gsap/all";
import _ from "underscore";

export default class Header {

  constructor() {
    this.html = document.querySelector('html');
    this.header = document.querySelector('.header');
    this.lastScrollTop = 0;

    window.addEventListener('scroll', (event) => {
      this.scrollHandler();
    });
    this.scrollHandler()


    const resizeHandler = _.debounce(() => {
      this.html.style.setProperty('--header-height', this.header.clientHeight + 'px');
      ScrollTrigger.refresh();
    }, 100);

    window.addEventListener('resize', resizeHandler);
    resizeHandler();
  }

  scrollHandler() {
    // this.html.style.setProperty('--header-height-current', this.header.clientHeight + 'px');

    this.header.classList.toggle('has-scrolled', this.html.scrollTop > this.header.clientHeight - 40);

    // // scrolling up
    // if (this.html.scrollTop > this.threshold && this.lastScrollTop < this.html.scrollTop) {
    //   this.header.classList.add('has-scrolled');
    // }

    // // scrolling down
    // if (this.lastScrollTop > this.html.scrollTop) {
    //   this.header.classList.remove('has-scrolled');
    // }

    // // save scroll position
    // this.lastScrollTop = this.html.scrollTop
  }
}
